import React, { useContext, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import produce from 'immer';

const switchContextShape = {
    expression: () => null,
    canDisplayDefault: false,
    registerCase: () => null,
    canDisplayCurrentCase: () => null
};

const SwitchContext = React.createContext(switchContextShape);

const Switch = ({ expression, children }) => {
    const [matchedCases, setCaseMatched] = useState({});
    const [canDisplayDefault, setCanDisplayDefault] = useState(true);
    const registerCase = (id, value) => setCaseMatched(produce((draft) => {
        if (value) {
            draft[id] = value;
        } else {
            delete draft[id];
        }
        setCanDisplayDefault(draft.extensions.isEmpty());
    }));
    const canDisplayCurrentCase = (id) => matchedCases.extensions.hasOnly(id);
    return (
        <SwitchContext.Provider
            value={{
                expression,
                canDisplayCurrentCase,
                registerCase,
                canDisplayDefault
            }}
        >
            {children}
        </SwitchContext.Provider>
    );
};
export default Switch;

Switch.propTypes = {
    expression: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
};

export const Case = ({ condition, children }) => {
    const [display, setDisplay] = useState(false);
    const { current: id } = useRef(uuid());
    const { expression, registerCase, canDisplayCurrentCase } = useContext(SwitchContext);
    const shouldCaseBeRendered = condition(expression);
    useEffect(() => {
        registerCase(id, shouldCaseBeRendered);
        setDisplay(canDisplayCurrentCase(id));
    }, [shouldCaseBeRendered, canDisplayCurrentCase]);

    return (
        <>
            {display && children}
        </>
    );
};

Case.propTypes = {
    condition: PropTypes.func.isRequired
};
export const Default = ({ children }) => {
    const { canDisplayDefault } = useContext(SwitchContext);
    return (
        <>{ canDisplayDefault && children}</>
    );
};